import React, { useState } from 'react';
import { Grid, Box, Button } from '@material-ui/core';
import MembershipPerksWrapper from './membership-perks-wrapper';
import { Input, UploadFile, CheckboxInput } from './membership-perk-form-components';
import { useHistory } from 'react-router';

import SCHEMA from '../../constants/SCHEMA.gen.json';
import MEMBERSHIPS from '../../constants/MEMBERSHIP.gen.json';

const {
  membership_perk: { TITLE, DESCRIPTION, TIER, DISCOUNT, DISCOUNT_CODE, URL, IMAGE_URL },
} = SCHEMA;

const { SUBSCRIPTION_TIERS } = MEMBERSHIPS;

const IMAGE_TITLE = 'Image';
const IMAGE_BUTTON_TEXT = 'Select Image';
const TIER_SELECT_OPTIONS = Object.values(SUBSCRIPTION_TIERS);

const MembershipPerkForm = ({ values, onSave, isSaving }) => {
  const history = useHistory();

  const [form, setForm] = useState(values || {});

  function onChange({ target }) {
    const { name, value } = target;
    const limitedValue = charLimiter(name, value);
    setForm({ ...form, [name]: limitedValue });
  }

  async function saveMembershipPerk(evt) {
    evt.preventDefault();
    await onSave(form);
  }

  return (
    <MembershipPerksWrapper>
      <Grid item xs={12}>
        <form onSubmit={saveMembershipPerk}>
          <Input name={TITLE} value={form[TITLE]} onChange={onChange} />
          <Input name={DESCRIPTION} minRows={4} value={form[DESCRIPTION]} onChange={onChange} />
          <UploadFile
            name={IMAGE_URL}
            value={form[IMAGE_URL]}
            title={IMAGE_TITLE}
            buttonText={IMAGE_BUTTON_TEXT}
            onChange={onChange}
          />
          <CheckboxInput name={TIER} onChange={onChange} value={form[TIER]} options={TIER_SELECT_OPTIONS} />
          <Box> * Optional *</Box>
          <Input name={DISCOUNT} value={form[DISCOUNT]} onChange={onChange} />
          <Input name={DISCOUNT_CODE} value={form[DISCOUNT_CODE]} onChange={onChange} />
          <Input name={URL} value={form[URL]} onChange={onChange} />
          <Button type="submit" disabled={isSaving}>
            Save
          </Button>
          <Button disabled={isSaving} onClick={() => history.push('/membership-perks')}>
            Cancel
          </Button>
        </form>
      </Grid>
    </MembershipPerksWrapper>
  );
};

export default MembershipPerkForm;

function charLimiter(name, value) {
  if (name === DESCRIPTION) return value.substring(0, 256);
  if (name === TITLE) return value.substring(0, 100);
  return value;
}
